import { render, staticRenderFns } from "./BaseListSelectable.vue?vue&type=template&id=6aff64c0&lang=pug&"
import script from "./BaseListSelectable.vue?vue&type=script&lang=js&"
export * from "./BaseListSelectable.vue?vue&type=script&lang=js&"
import style0 from "./BaseListSelectable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports